import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FormField from './FormField';

const ModalForm = ({
  open,
  onClose,
  title,
  fields,
  onSubmit,
  initialValues = {},
  error = {},
  submitLabel = 'Save',
  maxWidth = 'sm',
  grid = false,
  columns = 2,
}) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData(initialValues);
  }, [initialValues, open]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle>
        {title}
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent
          sx={
            grid
              ? {
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gap: 2,
              }
              : {}
          }
        >
          {fields.map((field) => (
            <div
              key={field.name}
              style={
                grid && field.fullWidth
                  ? { gridColumn: `span ${columns}` }
                  : {}
              }
            >
              {field.render ? (
                field.render({
                  value: formData[field.name],
                  onChange: (value) => handleChange(field.name, value),
                  error: error?.[field.name],
                })
              ) : (
                <FormField
                  field={field}
                  value={formData[field.name] || ''}
                  onChange={(name, value) => {
                    handleChange(name, value);
                    if (field.onChange) {
                      field.onChange(value);
                    }
                  }}
                  error={error?.[field.name]}
                />
              )}
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={onClose}>Cancel</Button> */}
          <Button type="submit" variant="contained" color="primary">
            {submitLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ModalForm;
